/* eslint-disable no-unused-expressions */
import React, { useEffect, useRef, useLayoutEffect } from 'react';
import MapImg from './img/map1.png';
import DefaulVideo from './img/defaultVideo.png';
import { Player } from '../../../../../video';
import ImgView from './components/ImgView';
import PropTypes from 'prop-types';
import styles from './index.css';
import Text from '../Text';
import Header from './components/Header';
import CircleInfoCard from './components/CircleInfoCard';
import errorBoundary from '@ifeng/errorBoundary';
import { reasonEnum } from './constant';
import { setH5PageTouchArea, setNoSlideArea, setPageNoActiveListener } from '../utils/app';
import { isIOS } from '../utils';
//import { getUrlParams } from '../utils';
import classnames from '../classnames/bind';
const cx = classnames.bind(styles);

const Template = ({
    useInfo = {},
    dataInfo = {},
    needFold,
    footerChildren,
    needHotLogo,
    needHeader = true,
    headChildren,
    onView = () => {},
    showCircleCard = false,
    orgInfo = {},
    joinCircleHandle = () => {},
    hiddenOwnerTag,
    forwardUser,
    showJoinBtn,
    additionalUserInfo,
    noBorder = false,
    needEditInfo,
    contentDetail = false,
}) => {
    const { txt, locationTxt } = dataInfo || {};
    const templeteWrapRef = useRef();
    const videoApis = useRef();
    const videoPosition = useRef();
    const playStatus = useRef();
    const playRef = useRef();
    //const { isCircle } = getUrlParams();
    let img = [];
    let video = {};
    let text = '';
    let tag = [];

    try {
        const { img: Img, video: Video, text: Text, tag: topicTag } = JSON.parse(txt);

        img = Img;
        video = Video;
        text = Text;
        tag = topicTag?.map(item => item?.name);
        tag = Array.from(new Set(tag));
    } catch (e) {
        // console.log(e);
    }

    useEffect(() => {
        setPageNoActiveListener(() => {
            // eslint-disable-next-line no-unused-expressions
            videoApis.current?.pause();
        });
    }, []);

    const mobileVideoData = {
        config: {
            auth: true,
            showTitle: false,
            showPoster: true,
            showController: true,
            m3u8Play: true,
            pauseAfterLeave: true,
            singlePlay: true,
            isCircle: true,
            clickVideoStatisticsCB: () => {
                // console.log('首次点击播放器区域自定义统计上报，只触发一次');
            },
            firstFrameStatisticsCB: () => {
                // console.log('视频开始播放首帧自定义统计上报');
            },
            getExposeApisCb: apis => {
                videoApis.current = apis;
            },
            fullscreenListener: isFull => {
                if (isIOS) {
                    return;
                }

                if (isFull) {
                    videoPosition.current = document.documentElement.scrollTop || document.body.scrollTop;
                } else {
                    window.scroll(0, videoPosition.current);
                }
            },
        },

        videoinfo: {
            mobileUrl: video?.src,
            bigPosterUrl: video?.posturl || DefaulVideo,
        },
    };
    const securityReason = reasonEnum[(dataInfo?.security)];
    let changeTab = () => {
        window.open(`https://group.ifeng.com/circles/contentDetail?id=${dataInfo.id}`, "_blank")
    }
    return (
        <>
            <div
                className={cx('template_wrap', { padding_bottom: showCircleCard && contentDetail })}
                style={{ border: noBorder ? 'none' : '' }}
                ref={templeteWrapRef}>
                {needHeader && (
                    <Header
                        additionalUserInfo={additionalUserInfo}
                        needHotLogo={needHotLogo}
                        dataInfo={dataInfo}
                        useInfo={useInfo}
                        headChildren={headChildren}
                        hiddenOwnerTag={hiddenOwnerTag}
                        needEditInfo={needEditInfo}
                    />
                )}
                <div>
                    {securityReason ? (
                        <>
                            <div className={styles.forward_delete_wrap}>发布的{securityReason}</div>
                        </>
                    ) : (
                        <div className={styles.content}>
                            {text && (
                                <div className={styles.text} onClick={() => {changeTab()}}>
                                    <Text
                                        needFold={needFold}
                                        text={forwardUser?.nickName ? `@${forwardUser?.nickName}：${text}` : text}
                                        tag={tag}
                                        forwardUser={forwardUser}
                                    />
                                </div>
                            )}
                            <div className={styles.img_wrap}>
                                <ImgView img={img} />
                            </div>

                            {video?.src && (
                                <div
                                    ref={playRef}
                                    className={styles.video_wrap}
                                    onClick={() => {
                                        const { top, bottom } = playRef.current?.getBoundingClientRect();

                                        setNoSlideArea([{ top, end: bottom, type: 'fixed' }]);
                                        setH5PageTouchArea(top, bottom);
                                    }}>
                                    <Player
                                        videoConfig={{ ...mobileVideoData.videoinfo }}
                                        playermsg={{ ...mobileVideoData.config }}
                                    />
                                </div>
                            )}
                        </div>
                    )}

                    {showCircleCard && (
                        <CircleInfoCard
                            orgInfo={orgInfo}
                            showLocation={!!locationTxt}
                            joinCircleHandle={joinCircleHandle}
                            showJoinBtn={showJoinBtn}
                        />
                    )}
                    {locationTxt && (
                        <div className={styles.location}>
                            <img src={MapImg} alt="定位图标" />
                            <span>{locationTxt?.length > 15 ? `${locationTxt.substr(0, 15)}...` : locationTxt}</span>
                        </div>
                    )}
                </div>

                <div>{footerChildren}</div>
            </div>
        </>
    );
};

Template.propTypes = {
    /**
     * 用户信息
     */
    useInfo: PropTypes.object,
    /**
     * 数据信息
     */
    dataInfo: PropTypes.object.isRequired,
    /**
     * 需要热点的标识
     */
    needHotLogo: PropTypes.bool,
    // 是否需要折叠，默认为true
    needFold: PropTypes.object,
    /**
     * 查看全文的回调函数
     */
    onView: PropTypes.func,
    /**
     * 头部扩展元素
     */
    headChildren: PropTypes.any,
    /**
     * 底部扩展元素
     */
    footerChildren: PropTypes.any,
    /**
     * 是否需要头部信息
     */
    needHeader: PropTypes.any,
    /**
     * 展示圈子卡片
     */
    showCircleCard: PropTypes.bool,
    /**
     * 文章所述的圈子信息
     */
    orgInfo: PropTypes.object,
    /**
     * 加入圈子按钮点击事件
     */
    joinCircleHandle: PropTypes.func,
    /**
     * 隐藏圈主标签
     */
    hiddenOwnerTag: PropTypes.bool,
    /**
     * 转发的原帖子用户信息
     */
    forwardUser: PropTypes.object,
    /**
     * 是否展示加入按钮
     */
    showJoinBtn: PropTypes.bool,
    /**
     * 认证信息
     */
    additionalUserInfo: PropTypes.object,
    /**
     * true,不需边框
     */
    noBorder: PropTypes.bool,
    needEditInfo: PropTypes.bool,
    /**
     * 帖子详情页
     */
    contentDetail: PropTypes.bool,
};

export default errorBoundary(Template);
